module.exports = __webpack_public_path__ + "static/img/success.61fa3837.png";